import * as React from "react";
import { Radio, type RadioProps } from "@mui/material";
import { styled } from "@mui/material/styles";

const AtlanteRadioUncheckedIcon = styled("span")(() => ({
  display: "inline-block",
  width: 18,
  height: 18,
  borderRadius: "50%",
  boxSizing: "border-box",
  border: "2px solid #C5CDD8",
  backgroundColor: "#F5F7FA",
}));

const AtlanteRadioCheckedIcon = styled("span")(() => ({
  display: "inline-block",
  width: 18,
  height: 18,
  borderRadius: "50%",
  boxSizing: "border-box",
  // border: "2px solid #C5CDD8",
  backgroundColor: "#F5F7FA",
  padding: 0,

  "&::before": {
    content: '""',
    display: "block",
    width: "100%",
    height: "100%",
    borderRadius: "50%",
    backgroundImage: "linear-gradient(135deg, #6CCB8B 0%, #3975D0 100%)",
  },
}));

export function AtlanteRadio(props: RadioProps) {
  return (
    <Radio
      disableRipple
      color="default"
      icon={<AtlanteRadioUncheckedIcon />}
      checkedIcon={<AtlanteRadioCheckedIcon />}
      {...props}
    />
  );
}
